export enum StatisticsQueryType {
  SOLD_TO = 'soldTo',
  CATEGORY = 'category',
  ARTICLE = 'article',
  MONTH = 'month',
}
